const accordions = () => {
  $('.js-slider').on('init', function (event, slick, direction) {
    window.setTimeout(function () {
      $('.js-accordion-slider').hide()
    }, 200)
  })

  $('.js-accordion__header').click(function () {
    $(this)
      .next()
      .slideToggle(300, function () {
        window.dispatchEvent(new Event('resize'))
        $('.js-slider').slick('refresh')
      })
  })
}

export default accordions
